import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import PreviewImage from "../views/PreviewImage/PreviewImage";

const ModalPreviewImage = ({ isOpen, imageUrl, toggle }) => {
  const handleClose = () => {
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} className={"modal-lg "}>
      <ModalBody>
        <PreviewImage imageUrl={imageUrl} />
      </ModalBody>
    </Modal>
  );
};

export default ModalPreviewImage;
